import { render, staticRenderFns } from "./w-page-video-header.vue?vue&type=template&id=a12c5104"
import script from "./w-page-video-header.vue?vue&type=script&lang=js"
export * from "./w-page-video-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports